var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"white","flat":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"8","md":"8","align":"center"}},[_c('Login')],1),_c('v-col',{attrs:{"cols":"4","md":"4","align":"center"}},[_c('Links')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }